import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';
import {LoadMySitesAction, LoadMySitesFailAction, LoadMySitesSuccessAction, mySitesActionTypes} from '../actions/my-sites';
import {Site} from '../models/site';
import {SitesService} from '../../site/services/sites.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class MySitesEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(mySitesActionTypes.LOAD),
    debug('Load my Sites action received.'),
    switchMap((data: LoadMySitesAction) => this.mySitesService.getList(data.payload, null).pipe(
      map((result: SendBackResult<ArrayResponse<Site>>) => new LoadMySitesSuccessAction(result.data.array)),
      catchError(res => this.catchResponseError(res)),
    )))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(mySitesActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Sites list.'),
    map((action: LoadMySitesFailAction) =>
      error(this.translation.translate('MY_SITES_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions, private translation: L10nTranslationService , private mySitesService: SitesService, router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadMySitesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadMySitesFailAction(response['error'].message);
  }
}
